import PropTypes from 'prop-types'
import { Card, Accordion } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import Markdown from '../Markdown'
import { getPath } from '../../MultilingualRouter/MultilingualRouter'
import '../../styles/components/SendMoneyStyle.scss'
import ContextAwareToggle from '../ContextAwareToggle'

const SendMoney = ({ content = {}, cardClassName = '' }) => {
  const accordionsList = content?.accordions || content?.transfer_accordions
  // WTF? Due to different types of objects that are used as content, where is TS?
  const listWithData = accordionsList.data ? accordionsList.data : accordionsList

  return (
    <Card className={`border-0 shadow rounded-0 ${cardClassName}`}>
      <Card.Header className="bg-transparent text-primary card-title">
        <Card.Title className="m-0">
          <h2 className="h6 m-0 text-uppercase fw-bold">{content?.title}</h2>
        </Card.Title>
      </Card.Header>
      <Accordion defaultActiveKey="0">
        {listWithData.map((item, index) => {
          const { icon, title, urlId, description } = item.attributes || item
          return (
            <div key={item.id} className={`position-relative${index === 0 ? '' : ' border-top'}`}>
              <i className="material-icons text-primary send-money-item-icon">{icon}</i>
              <ContextAwareToggle eventKey={index.toString()} buttonClass="send-money-item">
                <Markdown>{title}</Markdown>
              </ContextAwareToggle>
              <Accordion.Collapse eventKey={index.toString()}>
                <div className="clearfix send-money-item-body">
                  <Markdown>{description}</Markdown>
                  {urlId && (
                    <Link className="btn btn-link h6 fw-bold float-end p-2" to={getPath(urlId)}>
                      {content?.readMore}
                    </Link>
                  )}
                </div>
              </Accordion.Collapse>
            </div>
          )
        })}
      </Accordion>
    </Card>
  )
}

SendMoney.propTypes = {
  content: PropTypes.instanceOf(Object),
  cardClassName: PropTypes.string
}

export default SendMoney
